import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    PaymentMethodCreateRequest, PaymentMethodPatchInBatchRequest,
    PaymentMethodResponse
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'

class PaymentMethodService {
    async create(request: PaymentMethodCreateRequest): Promise<PaymentMethodResponse> {
        const response = await axios.post<PaymentMethodResponse>(`/configuration/paymentMethods`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<PaymentMethodResponse>> {
        const response = await axios.put<IResponseAgGrid<PaymentMethodResponse>>(`/configuration/paymentMethods`, { ...filterModel }, { params })
        return response.data
    }

    async get(clientTypeId: number): Promise<PaymentMethodResponse> {
        const response = await axios.get<PaymentMethodResponse>(`/configuration/paymentMethods/${clientTypeId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/paymentMethods/batch`, { data: request })
        return response.data
    }

    async patch(request: PaymentMethodPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/paymentMethods/batch`, request)
        return response.data
    }
}

export const paymentMethodService = new PaymentMethodService()
